import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Das hier ist die Band von dasProject'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-band-10_imn8pe',
    alt: 'dasProject Foto Band',
    aspectRatio: 1.5
  },
  {
    type: 'group',
    position: 'right',
    text: 'Hier rockts!',
    firstImg: {
      id: 'dasproject-foto-band-09_bwprbl',
      alt: 'dasProject Foto Band',
      aspectRatio: 1.5
    },
    secondImg: {
      id: 'dasproject-foto-band-20_whndsm',
      alt: 'dasProject Foto Band',
      aspectRatio: 1.5
    }
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-band-29_nheydo',
    alt: 'dasProject Foto Band',
    aspectRatio: 1.5
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-band-02_h01ccs',
    alt: 'dasProject Foto Band',
    aspectRatio: 1.5
  }
]

const color = 'green'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Band' next={6} previous={4}/>
      </div>
    )
  }
}

exports.data = {
  color: 'green',
  number: 6
}



// WEBPACK FOOTER //
// ./band.js